import { t } from "@lingui/macro";
import React from "react";
import { Path, G, Defs, ClipPath, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const VisaIcon = (props: IconProps) => {
  return (
    <Icon width={24} height={24} viewBox="0 0 22 7" title={t`Visa`} {...props}>
      <G clipPath="url(#clip0_2614_44509)">
        <Path
          d="M9.53337 6.89902H7.75122L8.86591 0.122833H10.648L9.53337 6.89902Z"
          fill="#0068BE"
        />
        <Path
          d="M15.9939 0.288489C15.6424 0.151383 15.0849 0 14.3955 0C12.6355 0 11.3962 0.922667 11.3886 2.2418C11.374 3.21506 12.2759 3.75563 12.9505 4.08014C13.64 4.41175 13.8744 4.62818 13.8744 4.92376C13.8674 5.37772 13.3172 5.58697 12.8041 5.58697C12.0926 5.58697 11.7114 5.47909 11.132 5.22653L10.8973 5.11826L10.6479 6.63937C11.0659 6.82658 11.836 6.99272 12.6355 7C14.5055 7 15.7229 6.09161 15.7373 4.68586C15.7444 3.91448 15.2682 3.32342 14.2414 2.84043C13.6181 2.53039 13.2363 2.32133 13.2363 2.00409C13.2437 1.7157 13.5592 1.42031 14.2628 1.42031C14.8422 1.40584 15.2679 1.54276 15.5904 1.67977L15.7516 1.75173L15.9939 0.288489Z"
          fill="#0068BE"
        />
        <Path
          d="M18.3625 4.49846C18.5093 4.10917 19.074 2.60254 19.074 2.60254C19.0666 2.617 19.2205 2.20607 19.3085 1.95379L19.4331 2.53767C19.4331 2.53767 19.7705 4.15967 19.8438 4.49846C19.5653 4.49846 18.7145 4.49846 18.3625 4.49846ZM20.5624 0.122833H19.1839C18.7588 0.122833 18.4358 0.245281 18.2524 0.685056L15.6052 6.89892H17.4752C17.4752 6.89892 17.783 6.06258 17.8492 5.88246C18.0544 5.88246 19.8734 5.88246 20.1374 5.88246C20.1885 6.12036 20.35 6.89892 20.35 6.89892H22.0001L20.5624 0.122833Z"
          fill="#0068BE"
        />
        <Path
          d="M6.26278 0.122833L4.51746 4.74354L4.32674 3.80641C4.00407 2.72508 2.9921 1.55024 1.86279 0.966072L3.46144 6.89183H5.34602L8.14726 0.122833H6.26278Z"
          fill="#0068BE"
        />
        <Path
          d="M2.89665 0.122833H0.0293337L0 0.259748C2.23668 0.822067 3.71799 2.17751 4.3266 3.8067L3.70328 0.692434C3.60066 0.259652 3.2853 0.137109 2.89665 0.122833Z"
          fill="#0068BE"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_2614_44509">
          <Rect width="22" height="7" fill="white" />
        </ClipPath>
      </Defs>
    </Icon>
  );
};
